import { Injectable, Signal, signal } from '@angular/core';
import { GlobalBannerConfig } from './global-banner-config';

@Injectable({
  providedIn: 'root'
})
export class GlobalInlineBannerStateService {
  private readonly _$banner = signal<GlobalBannerConfig | undefined>(undefined);

  setBanner(config: GlobalBannerConfig): void {
    this._$banner.set(config);
  }

  get banner(): Signal<GlobalBannerConfig | undefined> {
    return this._$banner;
  }

  closeBanner(): void {
    this._$banner.set(undefined);
  }
}
